import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { RefreshCw, Trash2 } from "lucide-react";
import { API } from "../lib/apiClient";
import { Empty } from "./common";

export const daysLeftInTrash = (iso) => {
  if (!iso) return 30;
  const expiresAt = new Date(new Date(iso).getTime() + 30 * 24 * 3600 * 1000);
  return Math.max(0, Math.ceil((expiresAt - new Date()) / (24 * 3600 * 1000)));
};

export const DaysBadge = ({ iso }) => {
  const d = daysLeftInTrash(iso);
  return <span className={`badge ${d <= 7 ? "badge-red" : d <= 14 ? "badge-amber" : "badge-slate"}`}>{d} gün</span>;
};

const NAMES = { customer: "müşteri", quote: "teklif", appointment: "randevu" };

export function TrashOtherList({ kind, onRestored, onCount }) {
  const [items, setItems] = useState([]);
  const load = useCallback(() => axios.get(`${API}/trash/items`).then(({ data }) => { setItems(data || []); onCount?.(data || []); }).catch(() => setItems([])), [onCount]);
  useEffect(() => { load(); }, [load]);
  const rows = items.filter((i) => i.kind === kind);
  const restore = async (t) => {
    try {
      const { data } = await axios.post(`${API}/trash/items/${t.id}/restore`);
      onRestored?.(data.kind, data.item);
      load();
    } catch (e) { window.alert(e?.response?.data?.detail || "Geri yükleme başarısız."); }
  };
  const purge = async (t) => {
    if (!window.confirm(`Bu ${NAMES[kind]} KALICI olarak silinecek ve geri alınamaz. Emin misiniz?`)) return;
    try { await axios.delete(`${API}/trash/items/${t.id}`); load(); } catch { window.alert("Kalıcı silme başarısız."); }
  };
  if (!rows.length) return <Empty text={`Silinen ${NAMES[kind]} yok. Sildikleriniz buraya düşer ve 30 gün saklanır.`} />;
  return (
    <div className="panel">
      <table className="data-table" data-testid={`trash-table-${kind}`}>
        <thead><tr><th>Kayıt</th><th>Detay</th><th>Silinme Tarihi</th><th>Kalıcı Silinmeye</th><th style={{ textAlign: "right" }}>İşlem</th></tr></thead>
        <tbody>
          {rows.map((t) => (
            <tr key={t.id} data-testid={`trash-row-${kind}-${t.itemId}`}>
              <td><strong>{t.title}</strong></td>
              <td className="small muted">{t.sub || "—"}</td>
              <td className="small muted">{new Date(t.deletedAt).toLocaleString("tr-TR")}</td>
              <td><DaysBadge iso={t.deletedAt} /></td>
              <td style={{ textAlign: "right" }}>
                <div style={{ display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
                  <button className="primary-button small" data-testid={`trash-restore-${kind}-${t.itemId}`} onClick={() => restore(t)}><RefreshCw size={14} /> Geri yükle</button>
                  <button className="ghost-button danger" data-testid={`trash-purge-${kind}-${t.itemId}`} onClick={() => purge(t)} title="Kalıcı sil"><Trash2 size={14} /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
